import './sales-banner.scss';

class SalesBanner {
    constructor($element) {
        this.$salesBanner = $element;
        this.$salesBannerClose = $element.querySelector('[data-sales-banner="close"]');
        this.$siteHeader = document.querySelector('[data-siteheader]');
        this.$main = document.querySelector('[data-main]');
    }

    initialize() {
        if (this.getLocalStorage('salesBannerHidden')) {
            this.hideBanner();
        } else {
            this.$salesBanner.removeAttribute('inert');
            this.$salesBannerClose?.addEventListener('click', () => this.closeBanner());
            this.$siteHeader?.classList.add('siteheader--has-banner');
            if (this.$main) this.$main.style.paddingTop = '0';
        }
    }

    closeBanner() {
        this.setLocalStorage('salesBannerHidden', true);
        this.hideBanner();
        this.$siteHeader?.classList.remove('siteheader--has-banner');
    }

    hideBanner() {
        this.$salesBanner.classList.add('sales-banner--is-hidden');
        this.$salesBanner.setAttribute('inert', '');
    }

    setLocalStorage(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify({
                value: value,
                timestamp: Date.now()
            }));
        } catch (e) {
            console.warn('setLocalStorage went wrong:', e);
        }
    }

    getLocalStorage(key) {
        try {
            const item = localStorage.getItem(key);
            if (!item) return null;

            const data = JSON.parse(item);
            const maxAge = 60 * 24 * 60 * 60 * 1000;
            const isExpired = Date.now() - data.timestamp > maxAge;

            if (isExpired) {
                localStorage.removeItem(key);
                return null;
            }

            return data.value;
        } catch (e) {
            console.warn('getLocalStorage went wrong:', e);
            return null;
        }
    }
}

export { SalesBanner };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $salesBanner = $context.querySelectorAll('[data-sales-banner="root"]');

        if ($salesBanner.length > 0) {
            for (let i = 0; i < $salesBanner.length; i++) {
                const salesBanner = new SalesBanner($salesBanner[i]);
                salesBanner.initialize();
            }
        }
    }
});
